/**
 * This file was auto-generated by @gonfalon/openapi/generate.ts.
 * Do not make direct changes to the file.
 *
 * If you have any questions, reach out to #ask-frontend.
 */

import { mergeHeaders } from 'openapi-fetch';

import { getClient } from '../../internal/client';
import type { operations } from '../openapi';

export type GetEnvironmentReleasePlanPathParams = NonNullable<
  operations['GetEnvironmentReleasePlan']['parameters']['path']
>;

export interface Input extends GetEnvironmentReleasePlanPathParams {
  apiVersion?: string;
  header: NonNullable<operations['GetEnvironmentReleasePlan']['parameters']['header']>;
}

export async function GetEnvironmentReleasePlan(
  { apiVersion, header, ...path }: Input,
  { headers, signal }: { headers?: HeadersInit; signal?: AbortSignal } = {},
) {
  return getClient().GET('/api/v2/projects/{projectKey}/environments/{environmentKey}/release-plans/{releasePlanKey}', {
    params: { path, header },
    headers: apiVersion ? mergeHeaders(headers, { 'LD-API-Version': apiVersion }) : headers,
    signal,
  });
}
